import React from "react";
import { Box, Button, Typography } from "@mui/material";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";

interface MappingEmptyStateProps {
    title: string;
    subtitle?: string;
    actionButtonLabel?: string;
    onActionButtonClick?: () => void;
}

const MappingEmptyState: React.FC<MappingEmptyStateProps> = ({
    title,
    subtitle,
    actionButtonLabel,
    onActionButtonClick,
}) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                py: 4,
                px: 2,
                borderRadius: 2,
                border: "1px dashed",
                borderColor: "divider",
                mb: 3,
            }}
        >
            <AccountTreeOutlinedIcon
                sx={{ fontSize: 48, color: "text.disabled", mb: 1.5 }}
            />
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                {title}
            </Typography>
            {subtitle && (
                <Typography variant="body2" color="text.secondary">
                    {subtitle}
                </Typography>
            )}
            {actionButtonLabel && (
                <Button
                    variant="outlined"
                    onClick={onActionButtonClick}
                    sx={{ mt: 2 }}
                >
                    {actionButtonLabel}
                </Button>
            )}
        </Box>
    );
};

export default MappingEmptyState;
